import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router';
import Home from './pages/Home';
// import Products from './components/Products';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
// import Cart from './components/Cart';
import NotFound from './pages/NotFound';
import ThankYou from './pages/Thankyou';
import Services from './pages/Services';
import Faq from './pages/Faq';
import FloatingSocialIcons from './components/FloatingSocialIcons';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Home Page */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/services" element={<Services />} />
          <Route path="/faq" element={<Faq />} />
        </Routes>
        <FloatingSocialIcons />
      </div>
    </Router>
  );
}

export default App;